"use client";

// src/hovercard/utils/polygon.ts
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function getEventPoint(event) {
  return [event.clientX, event.clientY];
}
function isPointInPolygon(point, polygon) {
  var _point = _slicedToArray(point, 2),
    x = _point[0],
    y = _point[1];
  var inside = false;
  var length = polygon.length;
  for (var l = length, i = 0, j = l - 1; i < l; j = i++) {
    var _polygon$i = _slicedToArray(polygon[i], 2),
      xi = _polygon$i[0],
      yi = _polygon$i[1];
    var _polygon$j = _slicedToArray(polygon[j], 2),
      xj = _polygon$j[0],
      yj = _polygon$j[1];
    var _ref = polygon[j === 0 ? l - 1 : j - 1] || [0, 0],
      _ref2 = _slicedToArray(_ref, 2),
      vy = _ref2[1];
    var where = (yi - yj) * (x - xi) - (xi - xj) * (y - yi);
    if (yj < yi) {
      if (y >= yj && y < yi) {
        if (where === 0) return true;
        if (where > 0) {
          if (y === yj) {
            if (y > vy) {
              inside = !inside;
            }
          } else {
            inside = !inside;
          }
        }
      }
    } else if (yi < yj) {
      if (y > yi && y <= yj) {
        if (where === 0) return true;
        if (where < 0) {
          if (y === yj) {
            if (y < vy) {
              inside = !inside;
            }
          } else {
            inside = !inside;
          }
        }
      }
    } else if (y === yi && (x >= xj && x <= xi || x >= xi && x <= xj)) {
      return true;
    }
  }
  return inside;
}
function getEnterPointPlacement(enterPoint, rect) {
  var top = rect.top,
    right = rect.right,
    bottom = rect.bottom,
    left = rect.left;
  var _enterPoint = _slicedToArray(enterPoint, 2),
    x = _enterPoint[0],
    y = _enterPoint[1];
  var placementX = x < left ? "left" : x > right ? "right" : null;
  var placementY = y < top ? "top" : y > bottom ? "bottom" : null;
  return [placementX, placementY];
}
function getElementPolygon(element, enterPoint) {
  var rect = element.getBoundingClientRect();
  var top = rect.top,
    right = rect.right,
    bottom = rect.bottom,
    left = rect.left;
  var _getEnterPointPlaceme = getEnterPointPlacement(enterPoint, rect),
    _getEnterPointPlaceme2 = _slicedToArray(_getEnterPointPlaceme, 2),
    x = _getEnterPointPlaceme2[0],
    y = _getEnterPointPlaceme2[1];
  var polygon = [enterPoint];
  if (x) {
    if (y !== "top") {
      polygon.push([x === "left" ? left : right, top]);
    }
    polygon.push([x === "left" ? right : left, top]);
    polygon.push([x === "left" ? right : left, bottom]);
    if (y !== "bottom") {
      polygon.push([x === "left" ? left : right, bottom]);
    }
  } else if (y === "top") {
    polygon.push([left, top]);
    polygon.push([left, bottom]);
    polygon.push([right, bottom]);
    polygon.push([right, top]);
  } else {
    polygon.push([left, bottom]);
    polygon.push([left, top]);
    polygon.push([right, top]);
    polygon.push([right, bottom]);
  }
  return polygon;
}
export { getEventPoint, isPointInPolygon, getElementPolygon };